import { Location } from '@core/Router/locations';
import { lazy } from 'react';

const PricePage = lazy(() =>
    import(/* webpackChunkName: "price" */ '@price/ui/PricePage').then(m => ({ default: m.PricePage })),
);

export const priceLocations: Location[] = [
    {
        url: '/price-list-view',
        Component: PricePage,
    },
];
